<template>
  <div class="overall-bg pt-0">
    <b-container>
      <b-row class="stepperdiv">
        <b-col lg="6" md="6" sm="6" cols="2">
          <BackBtn :goback="$router.back" />
          <Headerlayout :headertext="$t('consumption.title')"></Headerlayout>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="2">
          <div class="d-flex align-items-center justify-content-end">
            <Footer @save="IsSubmit()" :goback="$router.back" :loading="SaveLoader" :label="label"
              v-if="!afterSave && IsDetails == 0" />
            <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print"
              v-if="IsDetails == 1" />
          </div>
        </b-col>
      </b-row>
      <FormLoader :loading="formloader" v-if="formloader" />
      <div class="row form-white-bg" v-else>
        <b-row>
          <b-col lg="2" md="4" sm="6">
            <div class="field">
              <label>{{ $t("consumption.consumptionid") }}</label>
              <!-- <TextField :required-icon="false" name="PO ID" id="PO ID" label="Consumption ID" :disabled="false"
              :rules="{ required: false, alphabet: false }" v-model="createrequestForm.DcNo" /> -->
              <div>
                <GetCode label="Consumption ID" name="Consumption NO." :FormId="Entitydata"
                  v-model="createrequestForm.DocNo" />
              </div>
            </div>
          </b-col>

          <!-- <b-row v-if="showConsumptiontype"> -->
          <b-row>
            <b-col lg="2" md="4" sm="6" v-if="IsDetails == 0">
              <div class="d-flex align-items-center pt-3 field">
                <!-- {{ type.typeCheck }} -->
                <Checkbox v-model="type.typeCheck" inputId="ingredient1" name="Consumption Type" :value="true"
                  :disabled="selectOptions.disabled || afterSave" @change="IsPatientOnChange" />
                <label for="ingredient1" class="ms-2 mb-0 pt-2">
                  {{ $t("consumption.ispatient") }}
                </label>
              </div>
            </b-col>

            <b-col lg="3" md="4" sm="6" cols="8" v-if="IsDetails == 0">
              <div class="field">
                <label>{{
                  UserPatientAutoCompleteLable == true
                    ? $t("consumption.choosepatient")
                    : $t("consumption.chooseuser")
                }}<span class="red"> *</span></label>
                <!-- <ManagedAt v-model:value="selectOptions.managedAt" :options="selectOptions.manage_options" @update:value="handleMangedValue" /> -->
                <AutoCompleteField v-model="selectOptions.UserId" :items="selectOptions.manage_options"
                  @keyup="LoadUser" @item-select="auto_change" name="UserId" :label="$t('5000.inventorymanagedat')"
                  :rules="{ required: true }" :required-icon="true" id="UserId"
                  :disabled="selectOptions.disabled || afterSave" />
                <!-- {{ selectOptions.UserId }} -->
                <!-- <div class="field">
                  <DropdownCustom :label="$t('consumption.chooseuser/patient')" v-model="selectOptions.UserId"
                    :items="selectOptions.manage_options" :placeholder="$t('item.selectreason')"
                    :rules="{ required: true }" :required-icon="true" :name="$t('consumption.chooseuser/patient')"
                    :id="$t('consumption.chooseuser/patient')" />
                </div> -->
              </div>
            </b-col>
            <b-col class="d-flex flex-row-reverse" v-if="afterSave">
              <div class="colourCodeStatusBg">
                <div class="confirmationtime" v-for="i1 in colourCodeList">
                  <div class="d-flex align-items-center gap-2">
                    <div class="confirmedicon" :style="{ backgroundColor: i1.OrderColor }"></div>
                    <p>{{ i1.StatusName }}</p>
                  </div>
                </div>
              </div>
            </b-col>

            <!-- <b-col lg="3" md="4" sm="6" v-if="type.typeCheck[0]">
              <div class="d-flex flex-wrap gap-3 pt-3 field">
                <div class="d-flex align-items-center">
                  <RadioButton v-model="createrequestForm.VisitType" inputId="ingredient1" name="Yes" value="1"
                    :disabled="selectOptions.disabled" />
                  <label for="ingredient1" class="radio-label">OP</label>
                </div>
                <div class="d-flex align-items-center">
                  <RadioButton v-model="createrequestForm.VisitType" inputId="ingredient2" name="No" value="2"
                    :disabled="selectOptions.disabled" />
                  <label for="ingredient2" class="radio-label">IP</label>
                </div>
              </div>
            </b-col> -->
          </b-row>
        </b-row>
        <b-row>
          <b-col lg="6" md="6" sm="6" cols="12">
            <div class="patientdetailspopupcard" v-if="PatientDetails.UIN">
              <!-- <div class="patientdetailspopupcard"> -->
              <div class="d-flex justify-space-between">
                <p v-if="PatientDetails.UIN">
                  UIN: <span>{{ PatientDetails.UIN }}</span>
                </p>
                <!-- <p v-if="PatientDetails.UIN"> Brand: <span></span></p>
              <p v-if="PatientDetails.UIN">Model: <span></span></p> -->
                <p v-if="PatientDetails.UIN">
                  Lens Power: <span>{{ PatientDetails.IolPower }}</span>
                </p>
              </div>
              <div class="firstdiv">
                <div>
                  <p v-if="PatientDetails.UIN">
                    MRN no: <span>{{ PatientDetails.MRNNo }}</span>
                  </p>
                  <p v-if="PatientDetails.UIN">
                    Name: <span>{{ PatientDetails.PatientName }}</span>
                  </p>
                </div>
                <div>
                  <p v-if="PatientDetails.UIN">
                    Surgery Name: <span>{{ PatientDetails.Surgery }}</span>
                  </p>
                  <p v-if="PatientDetails.UIN">
                    Patient Type:
                    <span>{{ PatientDetails.PatientType }}</span>
                  </p>
                  <p v-if="PatientDetails.UIN">
                    Treatment Type:
                    <span>{{ PatientDetails.treatmentType }}</span>
                  </p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="IsDetails == 0 && !afterSave">
            <!-- {{ items }} -->
            <Items @additemclick="AddItems" :show-fields="showFields" v-model:data-items="dataItems"
              :addItemData="items" :isFilterData="itemDatas" :commonItemProps="commonItemProps" @clearitem="clearItems"
              @ItemUpdated="ItemUpdated" />
          </b-col>
        </b-row>
        <!-- {{ items }} -->

        <b-row>
          <b-col>
            <Table v-model:value="items" :paginator="true" class="p-datatable-gridlines mt-3" :rows="10" dataKey="id"
              :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll" :columns="headers"
              :seriaNlumber="true">
              <template v-slot:Add>
                <span>
                  <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                </span>
              </template>
              <!-- <template v-slot:UOMSlot="{ data }">
                <span v-if="data.Editable">
                  <CustomDropdown
                    :items="data.UOMoption"
                    v-model="data.UOM"
                    :showClear="false"
                    @update:modelValue=""
                  >
                  </CustomDropdown>
                </span>
                <span v-else @click="ShowUOMDropdown(data)">{{
                  data.UOMName
                }}</span>
              </template> -->
              <template v-slot:action="{ data }">
                <span v-if="IsDetails == 0">
                  <EditIcon @click="IsConfirmEdit(data)" />
                  <DeleteIcon @click="ItemDeleteConfirm($event, data)" />
                </span>
              </template>
              <template v-slot:Itemname1="{ data }">
                <span :style="getColorStyle(data)">
                  {{ data.Itemname1
                  }}<span v-if="data.IsFreeItem === 1">(promo)</span>
                </span>
              </template>

              <template v-slot:ModelNumberNameSlot="{ data }">
                <p>
                  <span v-if="data.BrandName">{{ data.BrandName
                  }}<span v-if="data.ModelNumberName">
                      /{{ data.ModelNumberName }}
                      <span v-if="data.SizeName">/{{ data.SizeName }} </span>
                    </span>
                  </span>
                </p>
              </template>
              <template v-slot:ExpiryDate="{ data }">
                <span>
                  {{ data.ExpiryDate === "01-01-1900" ? "" : data.ExpiryDate }}
                </span>
              </template>
            </Table>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
  <Toast />
  <ConfirmPopup />

  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsItemEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeletedSuccessfully :visible="deletepop" @ok="deleteclosetrigger()" />
  <AlreadyExist :selectedcontent="selectedcontent" :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  PropType,
  computed,
  onMounted,
  watch,
} from "vue";
import BackBtn from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import Table from "../../../../../../components/FormComponents/NormalTable.vue";
import Items from "../../../../../../modules/Inventory/components/Transaction/Item.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import { useRoute, useRouter } from "vue-router";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import Service from "../../../../../../modules/Inventory/Service/StockOutService";
import commonservice1 from "../../../../../../modules/Inventory/Service/StoreService";
import commonservice from "../../../../../../modules/Inventory/Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import AutoCompleteField from "../../../../../../components/FormComponents/AutoComplete.vue";
import GetCode from "../../../../../../components/common/getcode.vue";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";

import moment from "moment";
import UnitMasterService from "../../../../../../modules/Inventory/Service/UnitMasService";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";
import StoreService from "../../../../../../modules/Inventory/Service/StoreService";
import DropdownCustom from "../../../../../../components/FormComponents/Dropdown.vue";
import { json } from "stream/consumers";
import PatientIssueService from "../../../../../../modules/Inventory/Service/PatientIssueService";
import Itemservice from "../../../../Service/ItemMasService";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import FormLoader from "../../../../../../components/FormComponents/FormSkeletonLoader.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    DropdownCustom,
    BackBtn,
    Headerlayout,
    Table,
    Items,
    Footer,
    CreateSuccessully,
    UpdatedSuccessfully,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    TextField,
    AutoCompleteField,
    GetCode,
    AlreadyExist,
    FormLoader,
    CrystalReportPrintPopUp

  },

  props: {
    PatientDetails: {
      type: Object,
      default: {},
    },
  },

  setup(props, { emit }) {
    debugger;
    //
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Hospital_Id = session.HospitalCode;
    let HMSBranchId = Number(session.HospitalBranchId);
    let colourCodeList = ref([
      { OrderColor: "red", StatusName: "No Stock" },
      { OrderColor: "blue", StatusName: "Partially Issued" },
      { OrderColor: "green", StatusName: "Issued" },
    ]);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //
    const formloader = ref(false);
    const toast = useToast();
    const confirm = useConfirm();

    const router = useRouter();
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const dataEdit = ref();
    const itemDatas = ref([]);
    let currentDate = new Date().toISOString().slice(0, 10);
    let loading = ref(false);
    let SaveLoader = ref(false);
    let List = ref([]);
    var arr: any = [];
    let EditFlag = 0;
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const routes = useRoute();
    const commonItemProps = ref({
      storeId: 0,
      type: 1,
      itemType: 3, //item type is for item autocomplete 0-only item label will show 1-item + barcode will show//3-batch wise
      IsFilter: 0,
      UOMFlag: true,
      ConsumptionFlag: true,
    });

    let StoreId: any = Number(routes.query.StoreId ?? 0);
    let queryBranchId = Number(routes.query.BranchId ?? 0);

    let status = routes.query.status ?? 0;
    let Type = routes.query.Type;
    let StockTransId = routes.query.StockTransId ?? 0;
    let OperationId = Number(routes.query.OperationId) ?? 0;
    let Entitydata = ref();
    let SaveFlag = ref(true);
    //Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = Number(routes.query.EntityId) ?? 0;
    commonItemProps.value.storeId = Number(StoreId);
    let showConsumptiontype = ref(false);
    let IsDetails = routes.query.IsDetail ?? 0;
    onMounted(() => {
      debugger;
      //UOM();
      formloader.value = true;
      LoadUser();
      if (StockTransId != 0) {
        IsEdit();
      }
      formloader.value = false;
    });

    const label = ref(t("btn.save"));
    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );

    const createrequestForm = ref({
      CreatedAt: currentDate,
      CreatedBy: 0,
      ModifiedBy: 0,
      Id: 0,
      DocType: "14",
      RefId: 0,
      RefNo: "",
      DocNo: "",
      DocDate: currentDate,
      RequestedQty: 0,
      StoreId: StoreId,
      Amount: 0,
      HospitalId: 0,
      BranchId: 0,
      UserId: 0,
      ConsumptionType: 0,
      PatientId: "0",
      VisitId: 0,
      VisitType: 0,
      ModifiedAt: "",
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      PatientCode: "",
      PatientName: "",
      UserCode: "",
      UserName: "",
      StoreBrMapId: 0,

      IsDraft: 0,

      StockOutDetailList: [],
    });
    const selectOptions = ref({
      manage_options: [],
      UserId: ref(),
      disabled: false,
    });
    const type = ref({
      visit_type: 1,
      typeCheck: false,
    });

    let remarks = ref({
      Remarks: "",
    });

    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      displayClass.value = "show";
      Editmodel.value = false;
      EditFlag = 1;
    }

    const alreadyexistpop = ref(false);
    let afterSave = ref(false);
    let selectedcontent = ref("Some Items has no stock");

    let showitemfield = ref(false);
    let showadditemfield = ref(true);

    function ShowItems() {
      showitemfield.value = true;
      showadditemfield.value = false;
    }

    let items: any = ref([]);
    let dupitems: any = ref([]);

    let showFields = {
      // Category: true,
      Name: {
        show: true,
        require: true,
      },
      //Batch: false,
      // PackSize: false,
      // UnitRate: false,
      Qty: {
        show: true,
        require: true,
      },
      AvailQty: {
        show: true,
        require: false,
      },
      ExpiryDate: {
        show: true,
        require: true,
      },
      UOM: {
        show: true,
        require: true,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
      Batch: {
        show: true,
        require: true,
      },
      Reason: {
        show: true,
        require: false,
      },

      // MRP: false,
      // Discount: false,
    };

    interface PatientDetails {
      UIN: string;
      MRNNo: string;
      PatientName: string;
      NextOfKin: string;
      Eye: string;
      Surgery: string;
      Lense: string;
      ExpectedAdmissionDate: Date | null;
      SiteId: number | 0;
      PatientType: string;
      IolPower: string;
      corporateName: string;
      Clinic: string;
      treatmentType: string;
      StockOutId: number | 0;
      StockOutDocNo: string;
      StockInId: number | 0;
      StockInDocNo: string;
    }

    const PatientDetails = ref<PatientDetails>({
      UIN: "",
      MRNNo: "",
      PatientName: "",
      NextOfKin: "",
      Eye: "",
      Surgery: "",
      Lense: "",
      ExpectedAdmissionDate: null,
      SiteId: 0,
      PatientType: "",
      IolPower: "",
      corporateName: "",
      Clinic: "",
      treatmentType: "",
      StockOutId: 0,
      StockOutDocNo: "",
      StockInId: 0,
      StockInDocNo: "",
    });

    const headers = [
      {
        header: t("storetabdetails.consumptiontable.Category"),
        field: "ItemCategory1",
        class: "smallwidth newcolumnfreezeleft1",
      },
      {
        header: t("storetabdetails.consumptiontable.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.consumptiontable.Name"),
        field: "Itemname1",
        slot: "Itemname1",
        fieldDisplay: "false",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft3",
      },

      {
        header: t("storetabdetails.consumptiontable.Brand/Model/Size"),
        field: "BatchNo",
        slot: "ModelNumberNameSlot",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
        sortable: false,
        fieldDisplay: "false newcolumnfreezeleft4",
      },
      {
        header: t("storetabdetails.consumptiontable.UOM"),
        field: "UOMName",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.consumptiontable.IssueQty"),
        field: "ItemQuantity",
        editable: true,
        class: "editable smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.consumptiontable.BatchNo"),
        field: "BatchNo",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.consumptiontable.ExpiryDate"),
        field: "ExpiryDate",
        slot: "ExpiryDate",
        fieldDisplay: "false",
        class: "smallwidth newcolumnfreezeleft5",
      },
      {
        header: t("storetabdetails.consumptiontable.ReasonName"),
        field: "ReasonName",
        class: "smallwidth",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position",
        fieldDisplay: "false",
      },
    ];

    const AddItems = async (value) => {
      console.log(value);
      dupitems.value = [];
      items.value = await value.map((item) => ({
        ...item,
        StockStatus: 3,
        StoreId: StoreId,
        BranchId: queryBranchId,
        HospitalId: HospitalId,
      }));
      const lastIndex = Number(items.value.length - 1);
      dupitems.value.push(items.value[lastIndex]);
    };

    const display = ref(true);
    const displayClass = ref("");
    const dataItems = ref({});

    const getstorevalue = (value) => {
      console.log(value);
      createrequestForm.value = value;
    };
    async function IsEdit() {
      debugger;
      let result = await Service.GetById(StockTransId);
      result = result["result"];
      items.value = result;
      Object.keys(createrequestForm.value).forEach((key) => {
        if (result[0][key]) createrequestForm.value[key] = result[0][key];
      });

      let chk: any = createrequestForm.value.ConsumptionType == 2 ? [true] : [];
      type.value.typeCheck = chk;
      // createrequestForm.value.VisitType = String(
      //   createrequestForm.value.VisitType
      // );
      selectOptions.value.UserId =
        createrequestForm.value.ConsumptionType == 1
          ? result[0]["UserName"]
          : result[0]["PatientName"];

      createrequestForm.value.UserId = result[0]["UserId"]
        ? Number(result[0]["UserId"])
        : 0;
      createrequestForm.value.PatientId = result[0]["PatientId"]
        ? String(result[0]["PatientId"])
        : "0";

      createrequestForm.value.VisitId = result[0]["VisitId"]
        ? Number(result[0]["VisitId"])
        : 0;
      createrequestForm.value.PatientCode = result[0]["PatientCode"]
        ? result[0]["PatientCode"]
        : "";
      createrequestForm.value.PatientName = result[0]["PatientName"]
        ? result[0]["PatientName"]
        : "";
      createrequestForm.value.UserCode = result[0]["UserCode"]
        ? result[0]["UserCode"]
        : "";
      createrequestForm.value.UserName = result[0]["UserName"]
        ? result[0]["UserName"]
        : "";
      selectOptions.value.disabled = true;

      createrequestForm.value.DocDate = moment(
        createrequestForm.value.DocDate
      ).format("YYYY-MM-DD");

      //type.value.visit_type = createrequestForm.value.VisitType
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      setupHistoryManagement(router, 2);

      // router.push({
      //   name: "StoreTabDetails",
      //   query: {
      //     status: status,
      //     Id: StoreId,
      //     Type: Type,
      //   },
      // });
    }

    function deleteclosetrigger() {
      deletepop.value = false;
    }

    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }

    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Deletemodel.value = true;
    }

    // const LoadUOM = ref({
    //   UOMoption: [],
    //   UOMId: null,
    // });

    // // Load UOM
    // async function UOM() {
    //   debugger;
    //   try {
    //     const dataresponse = await UnitMasterService.getdata();

    //     console.log(dataresponse);
    //     debugger;

    //     LoadUOM.value.UOMoption = dataresponse["result"]
    //       .filter((x) => x.HospitalId == HospitalId)
    //       .map((item: any) => {
    //         item.name = item.Name;
    //         item.value = item.Id;
    //         return item;
    //       });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    // function ShowUOMDropdown(data) {
    //   debugger;
    //   data.Editable = true;
    //   data.UOMoption = LoadUOM.value.UOMoption;
    // }

    const IsSubmit = handleSubmit(async (values) => {
      SaveLoader.value = true;
      let response: any;
      let message = "";
      let id: any;
      let checkstockAvailabilityresult: any;

      debugger;

      // alert(selectOptions.value.UserId)
      if (selectOptions.value.UserId != 0) {
        if (items.value.length > 0) {
          createrequestForm.value.CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          createrequestForm.value.ModifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          createrequestForm.value.DocDate = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          createrequestForm.value.BranchId = queryBranchId;
          createrequestForm.value.HospitalId = HospitalId;
          createrequestForm.value.ModifiedBy = UserId;
          createrequestForm.value.CreatedBy = UserId;
          createrequestForm.value.EntityId = Number(Entitydata.value);
          createrequestForm.value.EntityOperationId = OperationId;
          // createrequestForm.value.UserId  =   selectOptions.value.UserId
          createrequestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

          createrequestForm.value.StoreBrMapId = Number(
            routes.query.storebranchmapid ?? 0
          );
          createrequestForm.value.ConsumptionType =
            type.value.typeCheck[0] == true ? 2 : 1;

          for (let i = 0; i < items.value.length; i++) {
            createrequestForm.value.Amount += parseFloat(
              items.value[i]["Totalvalue"] ? items.value[i]["Totalvalue"] : 0
            );
          }
          createrequestForm.value.Amount = Number(
            createrequestForm.value.Amount
          );
          createrequestForm.value.IsDraft = 0;

          debugger;
          checkstockAvailabilityresult =
            await Itemservice.CheckstockAvailability(
              items.value.filter((item) => item.ItemQuantity > 0)
            );
          debugger;
          const hasStockStatusOneOrTwo = checkstockAvailabilityresult[
            "result"
          ].some((item) => item.StockStatus === 1 || item.StockStatus === 2);
          const hasStockStatusZeroOrOne = checkstockAvailabilityresult[
            "result"
          ].some((item) => item.StockStatus === 0 || item.StockStatus === 1);
          debugger;
          items.value = items.value.map((item) => {
            const stockItem = checkstockAvailabilityresult["result"].find(
              (s) =>
                s.ItemId === item.ItemId &&
                s.Brand === item.Brand &&
                s.ModelNumber === item.ModelNumber &&
                s.Size === item.Size
            );

            if (stockItem) {
              return {
                ...item,
                StockStatus: stockItem.StockStatus,
                ItemQuantity:
                  stockItem.StockStatus === 1
                    ? stockItem.StockInHand
                    : stockItem.StockStatus === 0
                      ? 0
                      : item.ItemQuantity,
              };
            }

            return item;
          });
          debugger;
          if (hasStockStatusOneOrTwo) {
            if (StockTransId != 0) {
              id = StockTransId;
            } else {
              id = createrequestForm.value.Id;
              // createrequestForm.value.UserId =
              //   createrequestForm.value.ConsumptionType == 1
              //     ? Number(selectOptions.value.UserId["value"] || 0)
              //     : 0;
              // createrequestForm.value.PatientId =
              //   createrequestForm.value.ConsumptionType == 2
              //     ? String(selectOptions.value.UserId["value"] || "")
              //     : "";
              createrequestForm.value.VisitId =
                createrequestForm.value.ConsumptionType == 2
                  ? Number(selectOptions.value.UserId["visit_reportid"] || 0)
                  : 0;
            }

            debugger;
            for (let i = 0; i < items.value.length; i++) {
              let obj = {};
              (obj["StoreId"] = StoreId || 0),
                (obj["ItemId"] = items.value[i]["ItemId"]),
                (obj["Qty"] = items.value[i]["ItemQuantity"]),
                (obj["RefId"] = id),
                (obj["PackSizeId"] = items.value[i]["PackSizeId"]),
                (obj["HSNId"] = items.value[i]["HSNId"]),
                (obj["BarCodeNo"] = items.value[i]["BarCodeNo"]),
                (obj["BarCode"] = items.value[i]["BarCode"]),
                (obj["RoomId"] = items.value[i]["RoomId"] || 0),
                (obj["RackId"] = items.value[i]["RackId"] || 0),
                (obj["RowId"] = items.value[i]["RowId"] || 0),
                (obj["BoxId"] = items.value[i]["BoxId"] || 0),
                (obj["CreatedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["ModifiedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["CreatedBy"] = UserId),
                (obj["ModifiedBy"] = UserId),
                (obj["Id"] = items.value[i]["StockDetailsId"]),
                (obj["UOM"] = items.value[i]["UOM"]),
                (obj["BatchNo"] = items.value[i]["BatchNo"]),
                (obj["Brand"] =
                  items.value[i]["Brand"] == null
                    ? 0
                    : items.value[i]["Brand"]),
                (obj["ModelNumber"] =
                  items.value[i]["ModelNumber"] == null
                    ? 0
                    : items.value[i]["ModelNumber"]),
                (obj["Size"] =
                  items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);

              if (items.value[i]["ExpiryDate"]) {
                obj["ExpiryDate"] = moment(
                  items.value[i]["ExpiryDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
              }
              const today = new Date();
              (obj["PickStartTime"] = moment(today, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              )),
                (obj["PickEndTime"] = moment(today, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )),
                (obj["IsApproved"] = 1),
                (obj["UnitRate"] = items.value[i]["UnitRate"] || 0.0),
                (obj["Rate"] = items.value[i]["Rate"] || 0.0),
                (obj["PurchaseTax"] =
                  items.value[i]["PurchasePercentage"] || 0.0),
                (obj["PurchaseTaxAmount"] =
                  items.value[i]["Purchasetaxamount"] || 0.0),
                (obj["UserId"] =
                  createrequestForm.value.ConsumptionType == 1
                    ? Number(createrequestForm.value.UserId || 0)
                    : 0);
              obj["PatientId"] =
                createrequestForm.value.ConsumptionType == 2
                  ? String(createrequestForm.value.PatientId || "")
                  : "";

              obj["PatientName"] =
                createrequestForm.value.ConsumptionType == 2
                  ? String(createrequestForm.value.PatientName || "")
                  : "";

              (obj["StockInId"] = items.value[i]["StockInId"] || 0),
                (obj["StockInDetailId"] =
                  items.value[i]["StockInDetailId"] || 0),
                (obj["StockReasonId"] = items.value[i]["ReasonId"] || 0),
                (arr[i] = obj);
            }

            createrequestForm.value.StockOutDetailList = arr;
            let result = await Service.CreateConsumption(
              createrequestForm.value
            );
            id = result["result"][0].Id;
            createrequestForm.value.Id = id;
            for (
              let i = 0;
              i < createrequestForm.value.StockOutDetailList.length;
              i++
            ) {
              const ResultList = result["result"][0];
              items.value[i].Id = ResultList.StockOutDetailList[i]["Id"];
              items.value[i].StockDetailsId =
                ResultList.StockOutDetailList[i]["Id"];
            }

            let msgMapping = result["ErrorInfo"].ErrorCode;
            SaveFlag.value = true;
            if (hasStockStatusZeroOrOne) {
              alreadyexistpop.value = true;
              SaveLoader.value = false;
              afterSave.value = true;
            } else {
              if (SaveFlag.value == true) {
                if (id != "0") {
                  SaveLoader.value = false;
                  updatepop.value = true;
                } else {
                  SaveLoader.value = false;
                  successpop.value = true;
                }
              }
            }
          } else {
            alreadyexistpop.value = true;
            SaveLoader.value = false;
            afterSave.value = true;
          }
        } else {
          SaveLoader.value = false;
          toast.add({
            severity: "warn",
            summary: "Please Add the Item",
            detail: "",
            life: 3000,
          });
        }
      } else {
        SaveLoader.value = false;
        toast.add({
          severity: "warn",
          summary: "Please Choose the User",
          detail: "",
          life: 3000,
        });
      }
    });
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let UserPatientAutoCompleteLable = ref(false);

    function IsPatientOnChange() {
      debugger;
      if (type.value.typeCheck[0] == true) {
        UserPatientAutoCompleteLable.value = true;
      } else {
        UserPatientAutoCompleteLable.value = false;
      }
    }

    //User Loading
    async function LoadUser() {
      debugger;

      try {
        selectOptions.value.manage_options = [];
        console.log(selectOptions.value.UserId);
        var result;
        if (type.value.typeCheck[0] == true) {
          const Obj = ref({
            // Date: "2024-12-07",
            Date: moment().format("YYYY-MM-DD"),
            SiteId: Number(routes.query.SiteId) || 0,
          });

          // result = await PatientIssueService.GetSurgeryListMMS(Obj.value);
          result = await PatientIssueService.GetExpectedPatientSurgeryList(
            Obj.value
          );
          let SearchText = selectOptions.value.UserId;
          let regex = new RegExp(SearchText, "i");
          result["result"] = result["result"]
            .filter((x) => regex.test(x.uin) || regex.test(x.patientName))
            .map((x) => {
              x.UserName = x.uin + " - " + x.patientName;
              x.Code = x.mrno;
              x.ID = x.uin;
              x.Name = x.patientName;
              return x;
            });
        } else {
          result = await StoreService.ListUserByStoreId(
            StoreId,
            usersData.OrganizationId
          );
          result["result"] = result["result"].map((x) => {
            x.Name = x.UserName;
            return x;
          });
        }

        console.log(result);

        selectOptions.value.manage_options = result["result"].map((v) => ({
          label: v["UserName"],
          value: v["ID"],
          UserCode: v["Code"],
          UserName: v["Name"],
          PatientName: v["Name"],
          PatientCode: v["Code"],
          iolPower: v["iolPower"],
          mrno: v["mrno"],
          patientType: v["patientType"],
          treatmentType: v["treatmentType"],
          surgery: v["surgery"],
          uin: v["uin"],
        }));
      } catch (error) { }
    }

    //
    const IsSubmitDraft = handleSubmit(async (values) => {
      debugger;
      let response: any;
      let message = "";
      let id: any;
      debugger;
      if (selectOptions.value.UserId != 0) {
        if (items.value.length > 0) {
          createrequestForm.value.CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          createrequestForm.value.ModifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          createrequestForm.value.DocDate = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          createrequestForm.value.BranchId = queryBranchId;
          createrequestForm.value.HospitalId = HospitalId;
          createrequestForm.value.ModifiedBy = UserId;
          createrequestForm.value.CreatedBy = UserId;
          createrequestForm.value.EntityId = Number(Entitydata.value);
          createrequestForm.value.EntityOperationId = OperationId;
          // createrequestForm.value.UserId  =   selectOptions.value.UserId
          createrequestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

          createrequestForm.value.StoreBrMapId = Number(
            routes.query.storebranchmapid ?? 0
          );
          createrequestForm.value.ConsumptionType =
            type.value.typeCheck[0] == true ? 2 : 1;

          for (let i = 0; i < items.value.length; i++) {
            createrequestForm.value.Amount += parseFloat(
              items.value[i]["Totalvalue"] ? items.value[i]["Totalvalue"] : 0
            );
          }
          createrequestForm.value.Amount = Number(
            createrequestForm.value.Amount
          );
          //

          createrequestForm.value.IsDraft = 1;

          if (StockTransId != 0) {
            id = StockTransId;
          } else {
            id = createrequestForm.value.Id;
            createrequestForm.value.UserId =
              createrequestForm.value.ConsumptionType == 1
                ? Number(selectOptions.value.UserId["value"] || 0)
                : 0;
            createrequestForm.value.PatientId =
              createrequestForm.value.ConsumptionType == 2
                ? String(selectOptions.value.UserId["value"] || "")
                : "";
            createrequestForm.value.VisitId =
              createrequestForm.value.ConsumptionType == 2
                ? Number(selectOptions.value.UserId["visit_reportid"] || 0)
                : 0;
          }

          debugger;

          for (let i = 0; i < items.value.length; i++) {
            let obj = {};
            (obj["StoreId"] = StoreId || 0),
              (obj["ItemId"] = items.value[i]["ItemId"]),
              (obj["Qty"] = items.value[i]["ItemQuantity"]),
              (obj["RefId"] = id),
              (obj["PackSizeId"] = items.value[i]["PackSizeId"]),
              (obj["HSNId"] = items.value[i]["HSNId"]),
              (obj["BarCodeNo"] = items.value[i]["BarCodeNo"]),
              (obj["BarCode"] = items.value[i]["BarCode"]),
              (obj["RoomId"] = items.value[i]["RoomId"] || 0),
              (obj["RackId"] = items.value[i]["RackId"] || 0),
              (obj["RowId"] = items.value[i]["RowId"] || 0),
              (obj["BoxId"] = items.value[i]["BoxId"] || 0),
              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["CreatedBy"] = UserId),
              (obj["ModifiedBy"] = UserId),
              (obj["Id"] = items.value[i]["StockDetailsId"]),
              (obj["UOM"] = items.value[i]["UOM"]),
              (obj["BatchNo"] = items.value[i]["BatchNo"]),
              (obj["Brand"] =
                items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"]),
              (obj["ModelNumber"] =
                items.value[i]["ModelNumber"] == null
                  ? 0
                  : items.value[i]["ModelNumber"]),
              (obj["Size"] =
                items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);

            if (items.value[i]["ExpiryDate"]) {
              obj["ExpiryDate"] = moment(
                items.value[i]["ExpiryDate"],
                "DD-MM-YYYY"
              ).format("YYYY-MM-DD");
            }

            const today = new Date();
            (obj["PickStartTime"] = moment(today, "DD-MM-YYYY").format(
              "YYYY-MM-DD"
            )),
              (obj["PickEndTime"] = moment(today, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              )),
              (obj["IsApproved"] = 1),
              (obj["UnitRate"] = items.value[i]["UnitRate"] || 0.0),
              (obj["Rate"] = items.value[i]["Rate"] || 0.0),
              (obj["PurchaseTax"] =
                items.value[i]["PurchasePercentage"] || 0.0),
              (obj["PurchaseTaxAmount"] =
                items.value[i]["Purchasetaxamount"] || 0.0),
              // (obj["UserId"] = selectOptions.value.UserId['value'] ? Number(selectOptions.value.UserId['value']) : 0),
              // (obj["PatientId"] = selectOptions.value.UserId['value'] ? String(selectOptions.value.UserId['value']) : "0"),

              (obj["UserId"] =
                createrequestForm.value.ConsumptionType == 1
                  ? Number(selectOptions.value.UserId["value"] || 0)
                  : 0);
            obj["PatientId"] =
              createrequestForm.value.ConsumptionType == 2
                ? String(selectOptions.value.UserId["value"] || "")
                : "";

            (obj["StockInId"] = items.value[i]["StockInId"] || 0),
              (obj["StockInDetailId"] = items.value[i]["StockInDetailId"] || 0),
              (obj["StockReasonId"] = items.value[i]["ReasonId"] || 0),
              (arr[i] = obj);
          }

          createrequestForm.value.StockOutDetailList = arr;

          let result = await Service.createDraftStockOutMasterTM(
            createrequestForm.value
          );
          id = result["result"][0].Id;
          createrequestForm.value.Id = id;
          for (
            let i = 0;
            i < createrequestForm.value.StockOutDetailList.length;
            i++
          ) {
            const ResultList = result["result"][0];

            // items.value[items.value.length - 1].Id = ResultList.StockOutDetailList[0]['Id'];
            // items.value[items.value.length - 1].StockDetailsId = ResultList.StockOutDetailList[0]['Id'];

            items.value[i].Id = ResultList.StockOutDetailList[i]["Id"];
            items.value[i].StockDetailsId =
              ResultList.StockOutDetailList[i]["Id"];
          }
          // loading.value = false
        } else {
          toast.add({
            severity: "warn",
            summary: "Please Add the Item",
            detail: "",
            life: 3000,
          });
        }
      } else {
        toast.add({
          severity: "warn",
          summary: "Please Choose the User",
          detail: "",
          life: 3000,
        });
      }
    });

    //Item Delete

    const ItemDeleteConfirm = (event, data) => {
      confirm.require({
        target: event.currentTarget,
        message: "Do you want to delete this record?",
        icon: "pi pi-info-circle",
        rejectClass: "p-button-secondary p-button-outlined p-button-sm",
        acceptClass: "p-button-danger p-button-sm",
        rejectLabel: "Cancel",
        acceptLabel: "Delete",
        accept: () => {
          IsItemDelete(data);
        },
        reject: () => {
          toast.add({
            severity: "error",
            summary: "Rejected",
            detail: "You have rejected",
            life: 3000,
          });
        },
      });
    };

    async function IsItemDelete(data) {
      debugger;
      let msg = null,
        idChk = "";
      if (commonItemProps.value.itemType == 1) {
        idChk = "BarCodeNo";
      } else {
        idChk = "ItemId";
      }
      if (data["StockDetailsId"] && data["StockDetailsId"] != 0) {
        let result = await Service.DeleteStockOutDetailsTM(data.StockDetailsId);
        msg = result["ErrorInfo"].ErrorCode;
      }
      if (msg == null) {
        items.value = items.value.filter(
          (item) => item["" + idChk + ""] != data["" + idChk + ""]
        );

        toast.add({
          severity: "info",
          summary: "Confirmed",
          detail: "Record deleted",
          life: 3000,
        });
        return;
      } else {
        toast.add({
          severity: "error",
          summary: "Error",
          detail: msg,
          life: 3000,
        });
        return;
      }
      console.log(items.value);
    }

    function auto_change(event) {
      debugger;

      createrequestForm.value.ConsumptionType =
        type.value.typeCheck[0] == true ? 2 : 1;

      createrequestForm.value.UserId =
        createrequestForm.value.ConsumptionType == 1
          ? Number(event.value.value)
          : 0;

      createrequestForm.value.PatientId =
        createrequestForm.value.ConsumptionType == 2
          ? String(event.value.value)
          : "0";

      createrequestForm.value.VisitId =
        createrequestForm.value.ConsumptionType == 2
          ? Number(event.value.visit_reportid)
          : 0;

      createrequestForm.value.PatientCode =
        createrequestForm.value.ConsumptionType == 2
          ? event.value.PatientCode
          : "";

      createrequestForm.value.PatientName =
        createrequestForm.value.ConsumptionType == 2
          ? event.value.PatientName
          : "";

      createrequestForm.value.UserCode =
        createrequestForm.value.ConsumptionType == 1
          ? event.value.UserCode
          : "";

      createrequestForm.value.UserName =
        createrequestForm.value.ConsumptionType == 1
          ? event.value.UserName
          : "";
      if (type.value.typeCheck[0] == true) {
        UINNumberSelect(event);
      }
    }

    function getColorStyle(data) {
      // return data.IsFreeItem == 1 ? { color: "Red" } : {};
      if (data.StockStatus === 1) {
        return { color: "blue" };
      } else if (data.StockStatus === 0) {
        return { color: "red" };
      } else if (data.StockStatus === 2) {
        return { color: "green" };
      } else {
        return {}; // Default style (no color change)
      }
    }

    function clearItems(value1) {
      debugger;
      dataItems.value = {};
    }

    function ItemUpdated() {
      if (EditFlag == 1) {
        SaveFlag.value = false;
        // IsSubmit()
      }
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }

    const UINNumberSelect = (event) => {
      debugger;

      let PatientObj = selectOptions.value.manage_options.filter(
        (x: any) => x.value == event.value.value
      );

      GetPatientDetails(PatientObj[0]);
    };
    async function GetPatientDetails(Obj) {
      debugger;

      PatientDetails.value.UIN = Obj.uin;
      PatientDetails.value.MRNNo = Obj.mrno;
      PatientDetails.value.PatientName = Obj.PatientName;
      PatientDetails.value.Surgery = Obj.surgery;
      PatientDetails.value.PatientType = Obj.patientType;
      PatientDetails.value.IolPower = Obj.iolPower;
      PatientDetails.value.Surgery = Obj.surgery;
      PatientDetails.value.treatmentType = Obj.treatmentType;
    }

    const CrystalReportPopup = ref(false);
    const ParameterValues = ref({
      Id: 0,
      HospitalId: 0,
      BranchId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 72,
      HeaderTitle: "Consumption",
      ModuleId: 3,
    });

    function Print() {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = StockTransId;
      ParameterValues.value.HospitalId = HospitalId;
      ParameterValues.value.BranchId = queryBranchId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };


    return {
      label,
      SaveLoader,
      clearItems,
      Entitydata,
      List,
      getstorevalue,
      headers,
      showitemfield,
      ShowItems,
      showadditemfield,
      createrequestForm,
      AddItems,
      loading,
      items,
      showFields,
      display,
      displayClass,
      dataItems,
      successpop,
      updatepop,
      closetrigger,
      IsConfirmDel,
      dataEdit,
      Deletemodel,
      deletepop,
      Editmodel,
      IsConfirmEdit,
      deleteclosetrigger,
      itemDatas,
      IsItemEdit,
      IsSubmit,
      selectOptions,
      LoadUser,
      commonItemProps,
      IsItemDelete,
      type,
      auto_change,
      showConsumptiontype,
      getColorStyle,
      ItemUpdated,
      IsPatientOnChange,
      UserPatientAutoCompleteLable,
      ItemDeleteConfirm,
      IsDetails,
      alreadyexistpop,
      afterSave,
      selectedcontent,
      alreadyclosetrigger,
      colourCodeList,
      formloader,
      PatientDetails,
      UINNumberSelect,
      Print,
      ParameterValues,
      PrintType,
      CrystalReportPopup,
      hidepopup,
    };
  },
});
</script>
<style lang="scss">
.consumptionIdContainer {
  display: none;
}

.colourCodeStatusBg {
  background-color: #e9e7e7;
  padding: 10px 20px;
  border-radius: 5px;

  .confirmedicon {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }
}

.patientdetailspopupcard {
  background: #ffffff;
  padding: 10px 15px;
  border-radius: 10px;
  color: #000000;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  margin-bottom: 15px;
  // width: max-content;

  p {
    margin-bottom: 7px;
  }

  span {
    color: #000000;
  }

  .firstdiv {
    display: flex;
    padding: 15px 0px;

    div:nth-child(2) {
      border-left: 1px solid #e1e1e1;
      border-right: 1px solid #e1e1e1;
      padding-inline: 15px;
      margin-inline: 15px;
    }
  }
}
</style>
